const EXPECTED_OPERATIONAL_PATTERNS = [
  /^Attendance cannot be marked before the session starts$/i,
  /^Batch is no longer open for approval$/i,
  /^This batch has no [A-Z]{3} price\./i,
  /^Instructor schedule conflicts with session /i,
  /^Session date .+ must be between batch dates /i,
  /^Session end time must be later than its start time$/i,
  /^Please complete your profile before receiving a certificate\./i,
  /^No active enrollment for this course mode$/i,
  /^Logo must be less than 2MB$/i,
];

const isCrawler = (userAgent) =>
  /(?:applebot|googlebot|bingbot|yandexbot|baiduspider|duckduckbot)/i.test(
    String(userAgent || ""),
  );

const isNetworkFailure = (message) =>
  /^(?:TypeError:\s*)?(?:Failed to fetch|Load failed|NetworkError when attempting to fetch resource\.?)(?:\s*\([^)]*\))?$/i.test(
    String(message || "").trim(),
  );

export function isExpectedOperationalNoise(
  message,
  { userAgent = "", errorName = "" } = {},
) {
  const text = String(message || "").trim();
  if (EXPECTED_OPERATIONAL_PATTERNS.some((pattern) => pattern.test(text))) {
    return true;
  }

  if (
    errorName === "AbortError" ||
    /^signal is aborted without reason$/i.test(text)
  ) {
    return true;
  }

  return isCrawler(userAgent) && isNetworkFailure(text);
}

export { isNetworkFailure };
